
class CardsFontScaling 
{
	/**
	 * Sets font sizes on cards elements.
	 * 
	 * @param {*} step 
	 */
	setFontSizes(step)
	{
		this.setProgressText(step);
		this.setCardsNames(step);
		this.setCardsValues(step);
		this.setCardsValutes(step);
	}

	/**
	 * Removes all style attributes, so css can take over.
	 * 
	 */
	removeAll()
	{
		let progressText = document.querySelectorAll('.progress-text');
		let leftNames = document.querySelectorAll('.coins-body-left-upper');
		let rightNames = document.querySelectorAll('.coins-body-right-upper');
		let elementsValue = document.querySelectorAll('.card-value');
		let elementsValutes = document.querySelectorAll('.card-valute');
		
		for (var i = 0; i < progressText.length; i ++) {
			progressText[i].removeAttribute('style');
			leftNames[i].removeAttribute('style');
			rightNames[i].removeAttribute('style');
			for (var l = 0; l < elementsValue.length; l++) {
				elementsValue[l].removeAttribute('style');
				elementsValutes[l].removeAttribute('style');
			}
		}
	}

	/**
	 * Sets progress text size.
	 * 
	 * @param {*} step 
	 */
	setProgressText(step)
	{
		let enumObj = {
			1 : '0.6vw',
			2 : '0.8vw',
			3 : '0.9vw',
			4 : '1.1vw',
			5 : '1.9vw',
			6 : '2.2vw',
			7 : '2.2vw',
			m : '2.9vw'
		};

		let elements = document.querySelectorAll('.progress-text');
		for (let i = 0; i < elements.length; i ++) {
			elements[i].style.fontSize = enumObj[step];
		}
	}

	/**
	 * Sets cards name font sizes.
	 * 
	 * @param {*} step 
	 */
	setCardsNames(step)
	{
		let enumObj = {
			1 : '0.9vw',
			2 : '1.1vw',
			3 : '1.1vw',
			4 : '1.4vw',
			5 : '1.8vw',
			6 : '5.3vh',
			7 : '4.2vh',
			m : '3vw'
		};
		
		let leftNames = document.querySelectorAll('.coins-body-left-upper');
		let rightNames = document.querySelectorAll('.coins-body-right-upper');

		for (let i = 0; i < leftNames.length; i ++) {
			leftNames[i].style.fontSize = enumObj[step];
			rightNames[i].style.fontSize = enumObj[step];
		}
	}

	/**
	 * Sets cards values font sizes.
	 * 
	 * @param {*} step 
	 */
	setCardsValues(step)
	{
		let enumObj = {
			1 : '1.4vw',
			2 : '1.3vw',
			3 : '1.2vw',
			4 : '1.8vw',
			5 : '3.0vw',
			6 : '3.0vw',
			7 : '2.8vw',
			m : '4vw'
		};
		
		let elementsValue = document.querySelectorAll('.card-value');
		for (let i = 0; i < elementsValue.length; i ++) {
			elementsValue[i].style.fontSize = enumObj[step];
		}
	}

	/**
	 * Sets cards valutes font sizes.
	 * 
	 * @param {*} step 
	 */
	setCardsValutes(step)
	{
		let enumObj = {
			1 : '0.7vw',
			2 : '0.8vw',
			3 : '0.8vw',
			4 : '1vw',
			5 : '1.8vw',
			6 : '1.9vw',
			7 : '1.9vw',
			m : '2vw'
		};
		
		let elements = document.querySelectorAll('.card-valute');
		for (let i = 0; i < elements.length; i ++) {
			elements[i].style.fontSize = enumObj[step];
		}
	}
}

export default CardsFontScaling;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/js/cards-fonts-scaling.js
// module id = 1992
// module chunks = 4